<template>
	<section class="content" :class="{ 'no_icon': !icon }" ref="content">
		<div class="content__icon" v-if="icon">
			<div class="ll-container">
				<span :style="{ paddingBottom: 100 * icon.height / icon.width + '%' }"></span>
				<img v-lazy="icon.url" alt="icon"/>
			</div>
		</div>
		<div class="content__text" v-html="content" :class="{ 'no_icon': !icon }"></div>
	</section>
</template>

<script>
import { firstEnterElement } from '@/mixin/firstEnterElement.js'


export default {
	name: 'ContentBrand',
	props: ['content', 'icon'],
	mixins: [firstEnterElement],
	mounted() {
		this.open(this.$refs.content)
	}
}
</script>

<style scoped lang="scss">
.content {
	display: flex;
	flex-direction: column;
	width: returnColumnOffset(10, mobile);
	margin: 0 auto;
	@include spaceModulesBrand;

	@include mq($from: desktop) {
		width: 100%;
		flex-direction: row;
		&.no_icon {
			width: returnColumnOffset(12)
		}
	}

	&__icon {
		width: 39.77%;
		margin-bottom: 30px;

		@include mq($from: desktop) {
			margin: 0 returnColumnOffset(1);
			flex: 0 0 returnColumnOffset(3);
		}
	}

	&__text {
		@include mq($from: desktop) {
			flex: 0 0 returnColumnOffset(13);
		}

		& /deep/ h2 {
			@include fontBarlowCondensedSemibold;
			font-size: 3.6rem;
			margin-bottom: 20px;
			line-height: calc(30/30);
			font-size: calc(25px + (30 - 25) * ((100vw - 320px) / (519 - 320)));
			text-transform: uppercase;

			@include mq($from: tablet) {
				font-size: calc(30px + (46 - 30) * ((100vw - 520px) / (979 - 520)));
				line-height: calc(46/46);
				margin-bottom: 30px;
			}

			@include mq($from: desktop) {
				font-size: calc(46px + (78 - 46) * ((100vw - 980px) / (2560 - 980)));
				line-height: calc(60/60);
				margin-bottom: 32px;
			}
		}

		& /deep/ p {
			@include fontBarlowMedium;
			font-size: 1.4rem;
			line-height: calc(24/14);

			@include mq($from: desktop) {
				margin-right: 7.64%;
			}
		}

		&.no_icon {
			width: 100%;
			flex: 0 0 100%;
				& /deep/ p {
					margin-right: 0;
				}
		}
	}
}
</style>